import classNames from 'classnames';
import CloseButton from '@/shared/components/configurator/CloseButton';
import ConstructorButton from '@/shared/components/configurator/ConstructorButton';
import {
    useConfiguratorOpenedCameraPositionValue,
    useSetCameraPosition,
} from '@/shared/components/configurator/atoms/camera-position';
import { useSetConfiguratorStepState } from '@/shared/components/configurator/atoms/configurator-step-state';
import { useConfiguratorZoomedSetState } from '@/shared/components/configurator/atoms/configurator-zoomed';
import {
    useCurrentModelStateValue,
    useSetCurrentModelState,
} from '@/shared/components/configurator/atoms/current-model-state';
import { useCurrentPickerStateValue } from '@/shared/components/configurator/atoms/current-picker-state';
import { pickerDict } from '@/shared/components/configurator/dicts/picker-dict';
import { addUniqueItemToArray } from '@/shared/lib/utils/arrays/add-unique-item-to-array';

const ConfiguratorMultiPicker = () => {
    const setStep = useSetConfiguratorStepState();
    const picker = useCurrentPickerStateValue();
    const currentModelState = useCurrentModelStateValue();
    const setCurrentModelState = useSetCurrentModelState();
    const setCameraPosition = useSetCameraPosition();
    const configuratorOpenedCameraPosition = useConfiguratorOpenedCameraPositionValue();
    const setConfiguratorZoomed = useConfiguratorZoomedSetState();

    return (
        <div className="configurator">
            <div className="configurator-top">
                {/* @ts-ignore */}
                <div className="configurator-title text-l">Выберите несколько {pickerDict[picker.title]}</div>
                <CloseButton
                    onClick={() => {
                        setStep('hero');
                        setCameraPosition(configuratorOpenedCameraPosition);
                    }}
                />
            </div>
            <ul className="picker-list list-unstyled">
                {picker.property.map((item, i) => {
                    const currentModelPicker = currentModelState[picker.slug];
                    return (
                        <li key={i}>
                            <button
                                className={classNames('picker-item', {
                                    'picker-item--active':
                                        currentModelPicker &&
                                        Array.isArray(currentModelPicker) &&
                                        currentModelPicker.some((innerItem) => innerItem.value === item.slug),
                                })}
                                onClick={() => {
                                    setCurrentModelState((prev) => {
                                        const curPicker = prev[picker.slug];
                                        if (
                                            curPicker &&
                                            Array.isArray(curPicker) &&
                                            curPicker.some((innerItem) => innerItem.value === item.slug)
                                        ) {
                                            return {
                                                ...prev,
                                                [picker.slug]:
                                                    curPicker.filter((innerItem) => innerItem.value !== item.slug) ??
                                                    [],
                                            };
                                        }
                                        return {
                                            ...prev,
                                            [picker.slug]:
                                                Array.isArray(curPicker) && curPicker.length > 0
                                                    ? addUniqueItemToArray(curPicker, {
                                                          title: item.label,
                                                          value: item.slug,
                                                      })
                                                    : [
                                                          {
                                                              title: item.label,
                                                              value: item.slug,
                                                          },
                                                      ],
                                        };
                                    });
                                }}
                            >
                                <div className="text-m">{item.label}</div>
                                <div className="text-s picker-hint">{item.hint}</div>
                            </button>
                        </li>
                    );
                })}
            </ul>

            {picker.slug === 'boole' && (
                <div className="configurator-additional">
                    <div className="text-m">Особенности конструкции</div>
                    <div className="configurator-additional-hint text-xxs">
                        Одну из перегородок убрать нельзя по правилам проектирования конструкции павильона.
                    </div>
                </div>
            )}

            <div className="configurator-hero-buttons configurator-color-picker-buttons">
                <ConstructorButton
                    variant="blue"
                    onClick={() => {
                        setStep('hero');
                        setCameraPosition(configuratorOpenedCameraPosition);
                        setConfiguratorZoomed(false);
                    }}
                >
                    Сохранить и закрыть
                </ConstructorButton>
            </div>
        </div>
    );
};

export default ConfiguratorMultiPicker;
